import { METERS_PER_MILE } from "../../shared/route/index.ts";

export type Units = "mi" | "km";

/** Miles → display value in the chosen unit. */
export const conv = (miles: number, units: Units) => (units === "km" ? miles * 1.609344 : miles);

/** Rounded, localised number: one decimal under 100, whole above. */
export function fmt(n: number) {
  const v = n >= 100 ? Math.round(n) : Math.round(n * 10) / 10;
  return v.toLocaleString("en-US");
}

export const fmtMiles = (miles: number, units: Units) => `${fmt(conv(miles, units))} ${units}`;
export const fmtMeters = (meters: number, units: Units) => fmtMiles(meters / METERS_PER_MILE, units);
export const toMeters = (value: number, units: Units) => (units === "mi" ? value * METERS_PER_MILE : value * 1000);

export function fmtDate(iso: string) {
  return new Date(`${iso}T12:00:00`).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "2-digit" });
}
